import type { FC, ReactElement } from 'react';

import { FileEntityType } from '@core/types/file';
import { EntityFilesSection, type FileUploadsManager } from '@web/components/Files';

type Props = {
  quoteID: string | null;
  manager: FileUploadsManager;
};

export const QuoteFilesSection: FC<Props> = ({ quoteID, manager }): ReactElement => (
  <EntityFilesSection entityType={FileEntityType.Quote} entityId={quoteID} manager={manager} />
);
